import React from 'react';
import { LoadingIndicator } from 'lib/components';
import { checkZoomIntegration, disconnectZoomIntegration } from 'lib/api';
import { BackToIntegrations } from './BackToIntegrations';
import { IntegrationHeadline } from './IntegrationHeadline';
import { Video } from './Video';
import { Gap } from 'lib/components/styles/layout';
import { Button } from 'react-covideo-common';
import { Trans, useTranslation } from 'react-i18next';
import { INTEGRATION_DETAILS_LIST } from 'lib/api/integrations/useGetAllIntegrations';

const ZOOM_URL = `https://zoom.us/oauth/authorize?response_type=code&client_id=${process.env.REACT_APP_ZOOM_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_ZOOM_REDIRECT_URL}`;

export const ZoomIntegration = () => {
  const [isConnected, setIsConnected] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const { t } = useTranslation();

  const checkIntegration = async () => {
    try {
      const response = await checkZoomIntegration();
      setIsConnected(response.authorized);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const connect = () => {
    window.location.href = ZOOM_URL;
  };

  const disconnect = async () => {
    const response = await disconnectZoomIntegration();

    if (response && response.success) {
      setIsConnected(false);
    }
  };

  React.useEffect(() => {
    checkIntegration();
  }, []);

  const integrationData = INTEGRATION_DETAILS_LIST.find(
    integration => integration.key === 'zoom'
  );

  return (
    <>
      <Gap flexDirection='row' justifyContent='space-between' width='100%'>
        <BackToIntegrations />
        <Button
          variant={isConnected ? 'destructive' : 'primary'}
          text={isConnected ? t('Disconnect') : t('Connect')}
          onClick={isConnected ? disconnect : connect}
        />
      </Gap>
      {loading && <LoadingIndicator isLoading={loading} height='300px' />}
      {!loading && (
        <>
          <IntegrationHeadline
            title='Covideo for Zoom'
            imgSrc='https://www.covideo.com/backoffice/images/zoom-logo.svg'
          />
          <Gap>
            <Video
              thumbnail='https://images.covideo.com/thumbnails/zoom_integration.png'
              videoSource='https://videos.covideo.com/website/zoom_integration.mp4'
            />

            {integrationData?.description.paragraphs.map(
              (paragraphKey: string) => {
                const href = integrationData?.description.links
                  ? integrationData.description.links[paragraphKey]
                  : '';

                return (
                  <div key={paragraphKey}>
                    <Trans
                      i18nKey={`zoom-INTEGRATION.${paragraphKey}`}
                      components={
                        href
                          ? [
                              <a href={href} target='_blank' rel='noreferrer'>
                                {' '}
                              </a>,
                            ]
                          : []
                      }
                    />
                  </div>
                );
              }
            )}
          </Gap>
        </>
      )}
    </>
  );
};
